<template>
  <v-main
    :style="{
      marginLeft: generalSpacingLeftRight + '%',
      marginRight: generalSpacingLeftRight + '%',
    }"
    style="margin-top: 100px"
  >
    <v-card min-height="250px" class="px-8 py-5" outlined>
      <v-img
        alt="nuvending logo"
        width="70px"
        src="../assets/nuvending_logo.jpeg"
      />
      <div class="mt-3">
        <h2 style="font-weight: 600">Sign In</h2>
      </div>
      <div class="mt-5">
        <v-form ref="form">
          <div>
            <p style="font-weight: bold">Email:</p>
            <div style="margin-top: -10px">
              <v-text-field
                v-model="email"
                outlined
                single-line
                dense
                @input="clear_error_message"
                :rules="[
                  () => !!email || 'This field is required',
                  () => validate_email(email) || 'E-mail must be valid',
                ]"
                :error-messages="email_error_message"
                :disabled="email_signing"
              ></v-text-field>
            </div>
          </div>
          <div>
            <p style="font-weight: bold">Password:</p>
            <div style="margin-top: -10px">
              <v-text-field
                v-model="password"
                type="password"
                outlined
                single-line
                dense
                @input="clear_error_message"
                :rules="[
                  () => !!password || 'This field is required',
                  () => password.length >= 9 || 'At least 9 characters',
                ]"
                :disabled="email_signing"
                :error-messages="password_error_message"
              ></v-text-field>
            </div>
          </div>
          <div class="mt-1">
            <v-btn
              :loading="email_signing"
              :disabled="email_signing"
              block
              style="text-transform: capitalize"
              depressed
              color="primary"
              class="white--text"
              @click="sign_in"
              >Log in</v-btn
            >
          </div>
        </v-form>
      </div>
    </v-card>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      email_error_message: "",
      password: "",
      password_error_message: "",
      email_signing: false,
      is_loading: false,
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",
    };
  },
  methods: {
    async sign_in() {
      if (this.$refs.form.validate()) {
        this.email_signing = true;
        var response = await this.send_http_request("signIn", {
          email_address: this.email,
          password: this.password,
        });
        this.email_signing = false;
        if (response.data.status == "OK") {
          var payload = {
            userName: response.data.username,
            userID: response.data.operator_id,
            userType: response.data.user_type,
            userCompanyDocId: response.data.company_doc_id,
            userRoleList: response.data.role_list,
            selectedMachine: "",
          };
          this.$store.dispatch("updateUserName", payload);
          this.$store.dispatch("updateUserID", payload);
          this.$store.dispatch("updateUserType", payload);
          this.$store.dispatch("updateUserCompanyDocId", payload);
          this.$store.dispatch("updateUserRoleList", payload);
          this.$store.dispatch("updateSelectedMachine", payload);
          await this.load_all_machines_basic_info();
          this.$router.push({ name: "HomeScreen" }).catch((error) => {});
        } else {
          this.email_error_message = "Invalid credentials";
          this.password_error_message = "Invalid credentials";
        }
      }
    },
    clear_error_message() {
      this.email_error_message = "";
      this.password_error_message = "";
    },
    validate_email(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    onKeyPress(e) {
      if (e.key == "Enter") {
        this.sign_in();
      }
    },
  },
  mounted() {},
  created() {
    // Update store
    var payload = { headerType: "noNeedHeader" };
    this.$store.dispatch("updateHeaderType", payload);
    window.addEventListener("keypress", this.onKeyPress);
  },
  beforeDestroy() {
    window.removeEventListener("keypress", this.onKeyPress);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 10;
        case "lg":
          return 30;
        case "xl":
          return 30;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>